import { useHasNextAvailableLesson } from '@services/api/graphql/hasNextAvailableLesson'
import { useHasPreviousAvailableLesson } from '@services/api/graphql/hasPreviousAvailableLesson'
import { useCallback, useState } from 'react'
import { useEnrollment } from './useEnrollment'
import { useCurrentLesson } from './useCurrentLesson'
import { useToastController } from '@tamagui/toast'

export function useAvailableLessons() {
  const { currentLesson } = useCurrentLesson()
  const { enrollment } = useEnrollment()
  const [hasNextContent, setHasNextContent] = useState<boolean | null>(null)
  const [hasPreviousContent, setHasPreviousContent] = useState<boolean | null>(
    null,
  )
  const { hasNextAvailableLesson } = useHasNextAvailableLesson(
    currentLesson?.id ?? 0,
    enrollment?.id ?? 0,
  )
  const { hasPreviousAvailableLesson } = useHasPreviousAvailableLesson(
    currentLesson?.id ?? 0,
    enrollment?.id ?? 0,
  )
  const toast = useToastController()

  const resetNextAndPreviousContent = useCallback(() => {
    setHasNextContent(null)
    setHasPreviousContent(null)
  }, [])

  const getIfHasNextAvailableLesson = useCallback(
    async (currentLessonId: number, enrollmentId: number) => {
      try {
        const { data } = await hasNextAvailableLesson(
          currentLessonId,
          enrollmentId,
        )
        return data
      } catch (error) {
        toast.show('Erro ao buscar próxima aula', {
          message: 'Tente novamente mais tarde',
          type: 'error',
        })
        return null
      }
    },
    [hasNextAvailableLesson, toast],
  )

  const getIfHasPreviousAvailableLesson = useCallback(
    async (currentLessonId: number, enrollmentId: number) => {
      try {
        const { data } = await hasPreviousAvailableLesson(
          currentLessonId,
          enrollmentId,
        )
        return data
      } catch (error) {
        toast.show('Erro ao buscar aula anterior', {
          message: 'Tente novamente mais tarde',
          type: 'error',
        })
        return null
      }
    },
    [hasPreviousAvailableLesson, toast],
  )

  return {
    hasNextContent,
    hasPreviousContent,
    setHasNextContent,
    setHasPreviousContent,
    resetNextAndPreviousContent,
    getIfHasNextAvailableLesson,
    getIfHasPreviousAvailableLesson,
  }
}
